module.exports = __webpack_public_path__ + "static/media/ico-ofertas-004.44de0123.svg";